import React from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { Flex, Container, useToken, VStack } from "@chakra-ui/react"

export function FeaturedImage({
  imagePosition,
  image,
  alt,
  children,
  reverse,
}) {
  const { rounded, boxShadow } = useToken("layerStyles", "foreground")

  const imgWrapperStyles = {
    boxShadow: useToken("boxShadow", boxShadow),
    borderRadius: useToken("radii", rounded),
    position: "absolute",
    overflow: "hidden",
    height: "100%",
    width: "100%",
    zIndex: "0",
    top: 0,
  }

  return (
    <Container flexDirection="column" display="flex">
      <Flex
        as="article"
        flexDirection={{
          lg: reverse ? "row-reverse" : "row",
          base: "column-reverse",
        }}
        justifyContent="space-between"
      >
        <VStack
          w={{ base: "100%", lg: 3 / 7 }}
          justify="center"
          align="start"
          spacing={6}
          py={4}
        >
          {children}
        </VStack>

        <Flex
          flexDirection="column"
          w={{ base: "100%", lg: "50%" }}
          mb={{ base: 6, lg: 0 }}
        >
          <Flex
            overflow={{ base: "hidden", lg: "visible" }}
            minHeight={{ base: "275px", lg: "400px" }}
            position="relative"
            flex="1"
            px="0"
          >
            <GatsbyImage
              image={image.childImageSharp.gatsbyImageData}
              style={{ ...imgWrapperStyles }}
              imgStyle={{
                objectPosition: imagePosition ? imagePosition : "center center",
              }}
              alt={alt}
            />
          </Flex>
        </Flex>
      </Flex>
    </Container>
  )
}
